<template>
  <div class="serviceContent">
    <div class="serviceHeader"></div>
    <div class="serviceMain">
      <div class="contentBox">
        <div class="introduce">
          <h4>公司简介</h4>
          <p>重庆巨基科技有限公司, 成立于2014年是国家级高新技术企业, 备案的节能服务公司, <span>是重庆市首家电力上市公司——重庆三峡水利电力(集团)股份有限公司(股票代码:600116)旗下控股子公司。</span></p>
          <p>
            公司立足重庆, 磨砺近10年, 以“技术保障绿色发展，科技推动低碳转型，数字提升能源效率”为驱动，聚焦综合能源服务、数字化运营、碳资产碳足迹管理三大核心业务，重点依托合同能源管理与能源托管模式，发展成为集能源咨询、能源工程、能源运营、能源增值、数字化运营、碳资产管理于一体的综合能源服务公司，为客户持续提供满意并超越期望的服务。
          </p>
          <img :src="require('@/assets/images/aboutUs/introduce.png')"
            alt="/">
        </div>
        <div class="titleBox">
          <h3>业务类型</h3>
          <p>公司在发展过程中，不断完善与突出自身综合能源服务，形成巨基服务体系，在服务内容、服务方式、服务水平等多个方面不断积累和总结经验，打造自身服务优势。</p>
        </div>
        <div class="businessType">
          <el-row type="flex"
            justify="space-between"
            v-for="v in businessType"
            :key="v.title">
            <el-col :span="item.num"
              v-for="item in v.col"
              :key="item.num">
              <div class="grid-content">
                <img v-if="item.num ==13"
                  :src="v.imgUrl"
                  alt="/">
                <div class="txtBox"
                  v-if="item.num ==8">
                  <h5>{{v.title}}</h5>
                  <p>{{v.content}}</p>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="titleBox">
          <h3>客户对象</h3>
          <p>公司致力于建筑领域的节能降碳服务，客户群体主要为公共建筑与工业建筑两大类型。其中，公共建筑包括政府机关、事业单位、医院、学校、酒店、商务办公建筑等；工业建筑主要为制造工厂、物流基地、产业园区等。</p>
        </div>
        <div class="connection">
          <el-row :gutter="20"
            v-for="(v,i) in connection"
            :key="i">
            <el-col :span="8"
              v-for="item in v.row"
              :key="item.title">
              <div class="grid-content">
                <img :src="item.imgUrl"
                  alt="/"
                  style="width:100%;height:87%">
                <p>{{item.title}}</p>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="titleBox">
          <h3>业务领域</h3>
          <p>公司扎根重庆，目标客户主要定位在南方地区，具体分布于西南、华东、华南、华中等地区，涉及建筑、能源、低碳等产业领域。未来，以适应公司发展需求，将战略性有序向北推进业务面，持续深耕相关产业领域，服务全国。</p>
        </div>
        <div style="width:90%;margin:0 auto">
          <img :src="require('@/assets/images/aboutUs/map.png')"
            alt="/"
            style="width:100%">
        </div>
        <div class="titleBox">
          <h3>合作模式</h3>
          <p>合同能源管理模式(EMC):合同能源管理模式下，巨基科技为客户提供以下三种子模式</p>
        </div>

      </div>
    </div>
    <div class="serviceFooter">
      <el-row type="flex"
        justify="space-between">
        <el-col :span="7"
          v-for="v in modelList"
          :key="v.title">
          <div class="grid-content bg-purple">
            <img :src="v.imgUrl"
              alt="">
            <h5>{{v.title}}</h5>
            <div class="line"></div>
            <p>{{v.content}}</p>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      businessType: [
        {
          col: [{ num: 13 }, { num: 8 }],
          title: "综合能源服务",
          content:
            "公司立足客户需要，在建筑节能领域提供综合能源服务、高效软件服务、设计咨询服务、综合工程服务。其中包括合同能源管理服务（节能效益分享型、节能量保证型、能源费用托管型）、软件的定制开发与销售服务、能源审计服务、方案咨询与设计服务、机电安装服务等。",
          imgUrl: require("@/assets/images/aboutUs/type1.png"),
        },
        {
          col: [{ num: 8 }, { num: 13 }],
          title: "数字化运营",
          content:
            "公司基于物联网设备、大数据处理能力等技术手段打造的数字底座, 以EMBS能源管理平台为载体, 搭建应用场景仿真模型，优化能源管理、设备管理、后勤管理等模块化运营策略，为客户的的数字化、智慧化运营的优化升级赋能。通过深入客户多应用场景的数据挖掘能力，实现生产以及后勤运营的场景动态化感知，赋能企业基层应用与中层管理；海量数据生成数据洞察，助力高层精准决策，达到辅助决策、节约成本、降低能耗、智慧化运营的目的。",
          imgUrl: require("@/assets/images/aboutUs/type2.png"),
        },
        {
          col: [{ num: 13 }, { num: 8 }],
          title: "碳管理",
          content:
            "公司着力打造的物联网平台，主要服务于政府的监管与考核、企业生产与运营的低碳转型。平台通过接入各类传感器、网关等设备，实现末端感知，精准跟踪和捕捉碳足迹，明确产品碳足迹、企业碳足迹等，帮助企业辨识产品生命周期中主要的温室气体排放过程与特征，实现“碳资产”、“碳足迹”的全周期管理，制定有效的碳减排方案和减排目标。",
          imgUrl: require("@/assets/images/aboutUs/type3.png"),
        },
      ],
      connection: [
        {
          row: [
            {
              title: "北京中医药大学深圳医院（龙岗）、厦门长庚医院…",
              imgUrl: require("@/assets/images/aboutUs/customers1.png"),
            },
            {
              title: "江苏海事职业技术学院、重庆工程学院…",
              imgUrl: require("@/assets/images/aboutUs/customers2.png"),
            },
            {
              title: "重庆恒大酒店、重庆巫山江山红叶酒店…",
              imgUrl: require("@/assets/images/aboutUs/customers3.png"),
            },
          ],
        },
        {
          row: [
            {
              title: "圳市坪山区政府大楼、深圳市横岗街道办事处…",
              imgUrl: require("@/assets/images/aboutUs/customers4.png"),
            },
            {
              title: "重庆协信星光时代广场、福建升龙大厦…",
              imgUrl: require("@/assets/images/aboutUs/customers5.png"),
            },
            {
              title: "重庆嘉峰物流园、重庆华林天美印务…",
              imgUrl: require("@/assets/images/aboutUs/customers6.png"),
            },
          ],
        },
      ],
      modelList: [
        {
          imgUrl: require("@/assets/images/aboutUs/model1.png"),
          title: "能源费用托管型",
          content:
            "能源服务公司受客户委托管理全部能源费用，承担节能设备长期的管理、维护、更新、改造再投入，客户零投资，与客户按比例长期分享节能效益。",
        },
        {
          imgUrl: require("@/assets/images/aboutUs/model2.png"),
          title: "节能效益分享型",
          content:
            "在节能效益承包型基础上，由能源服务公司投入全部投资，合同期内节能收益双方共享，期满后的节能收益归客户所有。",
        },
        {
          imgUrl: require("@/assets/images/aboutUs/model3.png"),
          title: "节能效益保障型",
          content:
            "即客户委托能源服务公司对其用能情况进行诊断、检测，提出改造方案，并协助客户进行投资改造，从而保证客户实现一定的节能效益。",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.serviceContent {
  width: 100%;
  overflow: auto;
  .serviceHeader {
    width: 100%;
    height: 339px;
    background: url("~@/assets/images/aboutUs/banner.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .serviceMain {
    width: 100%;
    background: #fff;
    .contentBox {
      width: 65%;
      margin: 0 auto;
      padding: 80px 0 10px;
      .introduce {
        width: 100%;
        h4 {
          font-size: 28px;
          font-weight: bold;
          color: #333333;
          line-height: 42px;
        }
        p {
          font-size: 14px;
          color: #666;
          line-height: 32px;
        }
        p:nth-child(2) {
          font-size: 16px;
          margin: 22px 0 12px;
          span {
            color: #333;
            font-weight: bold;
          }
        }
        img {
          width: 100%;
          margin-top: 32px;
        }
      }
      .titleBox {
        width: 43%;
        margin: 119px auto 50px;
        text-align: center;
        h3 {
          font-size: 26px;
          margin-bottom: 13px;
          position: relative;
        }
        h3:before,
        h3:after {
          content: "";
          position: absolute;
          width: 30px;
          height: 2px;
          top: 50%;
          background-color: #333;
        }
        h3:before {
          left: 30%;
        }
        h3:after {
          right: 30%;
        }
        p {
          color: #666;
          line-height: 28px;
        }
      }
      .el-row {
        margin-bottom: 30px;
        &:last-child {
          margin-bottom: 0;
        }
      }
      .businessType {
        width: 100%;
        .el-row {
          &:nth-child(1),
          &:nth-child(3) {
            h5 {
              text-align: right;
            }
          }
        }
        .grid-content {
          border-radius: 4px;
          height: 330px;
          @include setFlexCenter;
          img {
            width: 100%;
            height: 100%;
          }
          .txtBox {
            h5 {
              font-size: 20px;
              color: #28cccb;
              line-height: 26px;
              margin-bottom: 10px;
            }
            p {
              color: #333333;
              line-height: 30px;
            }
          }
        }
      }
      .connection {
        width: 100%;

        .grid-content {
          border-radius: 4px;
          height: 220px;
          @include setFlexColumn;
          justify-content: space-between;
          p {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-align: center;
          }
        }
      }
    }
  }
  .serviceFooter {
    width: 65%;
    margin: 0 auto;
    .el-row {
      margin: 70px 0 80px;
      .grid-content {
        h5 {
          font-size: 20px;
          font-weight: bold;
        }
        .line {
          width: 64px;
          height: 3px;
          background: #28cccb;
          margin: 22px 0 17px;
        }
        p {
          color: #666;
          line-height: 24px;
        }
      }
    }
  }
}
</style>